import Vue from "vue";

const bus = new Vue();

window.$bus = bus;